import React from "react";
import PaymentRouter from './Payment/Router';
export { getFields } from './Payment/Router';

export default function PaymentPmRouter(props){
    return <PaymentRouter {...props} mode='PM' />;
}